var kind      = require("enyo/kind"),
    Component = require("enyo/Component");

/**
 * [Animation]{@link enyo-anim.Animation} is a collection of [Animators]{@link
 * enyo-anim.Animator}.
 *
 * @class   enyo-anim.Animation
 * @extends enyo.Object
 * @public
 */
module.exports = kind(/** @lends enyo-anim.Animation.prototype */ {

    /**
     * @private
     */
    name: "enyo-anim.Animation",

    /**
     * @private
     */
    kind: Component,

    /**
     * A named hash of [Animators]{@link enyo-anim.Animator} with a
     * [Scalar]{@link enyo-anim.Scalar} and 0 or more [Attractors]{@link
     * enyo-anim.Attractor}.
     *
     * @type {Object}
     * @public
     */
    animators: null,

    /**
     * Ensures the class instance has an ownProperty `animators` if none was
     * passed to the constructor.
     *
     * @method
     * @private
     */
    importProps: kind.inherit(function(sup) {
        return function() {
            if (!this.hasOwnProperty("animators")) {
                this.animators = {};
            }
            sup.apply(this, arguments);
        };
    }),

    /**
     * Update all animated properties.
     *
     * @public
     */
    update: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name)) {
                animators[name].update();
            }
        }
    },

    /**
     * Determines if any of the animators are [attracted]{@link
     * enyo-anim.Animator#isAttracted}.
     *
     * @return {boolean}  `true` if attracted, `false` otherwise.
     * @public
     */
    isAttracted: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name) && animators[name].isAttracted() === true) {
                return true;
            }
        }

        return false;
    },

    /**
     * Determines if any of the animators are [moving]{@link
     * enyo-anim.Animator#isMoving}.
     *
     * @return {boolean}  `true` if moving, `false` otherwise.
     * @public
     */
    isMoving: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name) && animators[name].isMoving() === true) {
                return true;
            }
        }

        return false;
    },

    /**
     * Determines if all of the animators are [done]{@link
     * enyo-anim.Animator#isDone}.
     *
     * @return {boolean}  `true` if done, `false` otherwise.
     * @public
     */
    isDone: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name) && animators[name].isDone() === false) {
                return false;
            }
        }

        return true;
    },

    /**
     * Clears all attractors on all animators.
     *
     * @public
     */
    clearAttractors: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name)) {
                animators[name].clearAttractors();
            }
        }
    },

    /**
     * Snaps all attracted animators to their convergence point, but leaves
     * attractors in-tact. Stops all non-attracted animators at their current
     * state.
     *
     * @public
     */
    finish: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name)) {
                animators[name].finish();
            }
        }
    },

    /**
     * Stops the animation in it's current state and clears all attractors.
     *
     * @public
     */
    stop: function() {
        var name,
            animators = this.animators;

        for (name in animators) {
            if (animators.hasOwnProperty(name)) {
                animators[name].stop();
            }
        }
    }

});
